export default "varying vec3 vColor;\n\nvoid main()\n{\n    gl_FragColor = vec4(vColor, 1);\n}";